export enum DemoUsageType {
  RunOnline = 1,
  DownloadExcel = 2,
  DownloadPowerBI = 4,
}
